// extracted by mini-css-extract-plugin
module.exports = {"text":"EmptyList_text__154Cx"};